import React from "react";
import BothiesMap from "./components/BothiesMap";
import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <BothiesMap />
    </div>
  );
}

export default App;
